<template>
  <div class="main-box main-content">
     <el-form ref="dataForm"  id="dataForm" class="main-form" :model="temp" :rules="rules" label-width="110px" label-suffix="：">
      <xr-loading :is-loading="loading"></xr-loading>
       <!-- 基本信息 -->
       <xr-collapse  class="single-collapse" style="margin-top: 10px;">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="基本信息">
             <el-row :gutter="24">
               <el-col :span="6">
                 <el-form-item  label="档案编号">
                   <el-input  v-model="temp.archiveCode" disabled></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="姓名" prop="sickName" >
                   <el-input  v-model="temp.sickName" disabled></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="体检日期" prop="medicalTime">
                   <el-date-picker v-model="temp.medicalTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="责任医生" prop="medicalOperatorName">
                   <el-input  v-model="temp.medicalOperatorName" disabled></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="检查地点" prop="medicalWay">
                   <el-select v-model="temp.medicalWay" placeholder="请选择" @change="handleMedicalWayChange" style="width: 100%">
                     <el-option label="门诊" value="1"></el-option>
                     <el-option label="家庭" value="2"></el-option>
                     <el-option label="其它" value="3"></el-option>
                   </el-select>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="录入团队" >
                   <el-input  v-model="temp.teamName" disabled></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="录入医生" prop="createOpera">
                   <el-input  v-model="temp.medicalOperatorName" disabled></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="体检编号" prop="medicalNo">
                   <el-input  v-model="temp.medicalNo" disabled></el-input>
                 </el-form-item>
               </el-col>
             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse>

       <!-- 症状 -->
       <xr-collapse  class="single-collapse">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="症状">
             <el-row :gutter="24">
               <el-col :span="24">
                 <el-form-item label="症状" prop="asymptomatic">
                   <el-checkbox v-model="temp.asymptomatic" :true-label="'1'" :false-label="'0'" @change="handleAsymptomaticChange">无症状</el-checkbox>
                   <el-checkbox v-model="temp.symptomHeadache" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">头痛</el-checkbox>
                   <el-checkbox v-model="temp.symptomDizziness" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">头晕</el-checkbox>
                   <el-checkbox v-model="temp.symptomPalpitation" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">心悸</el-checkbox>
                   <el-checkbox v-model="temp.symptomChestStuffiness" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">胸闷</el-checkbox>
                   <el-checkbox v-model="temp.symptomChestPain" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">胸痛</el-checkbox>
                   <el-checkbox v-model="temp.symptomChronicCough" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">慢性咳嗽</el-checkbox>
                   <el-checkbox v-model="temp.symptomExpectoration" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">咳痰</el-checkbox>
                   <el-checkbox v-model="temp.symptomDyspnea" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">呼吸困难</el-checkbox>
                   <el-checkbox v-model="temp.symptomPolydipsia" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">多饮</el-checkbox>
                   <el-checkbox v-model="temp.symptomPolyuria" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">多尿</el-checkbox>
                   <el-checkbox v-model="temp.symptomWeightLoss" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">体重下降</el-checkbox>
                   <el-checkbox v-model="temp.symptomLackOfPower" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">乏力</el-checkbox>
                   <el-checkbox v-model="temp.symptomJointGall" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">关节肿痛</el-checkbox>
                   <el-checkbox v-model="temp.symptomBlurredVision" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">视力模糊</el-checkbox>
                   <el-checkbox v-model="temp.symptomHandFootNumbness" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">手脚麻木</el-checkbox>
                   <el-checkbox v-model="temp.symptomUrinaryUrgency" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">尿急</el-checkbox>
                   <el-checkbox v-model="temp.symptomDysuria" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">尿痛</el-checkbox>
                   <el-checkbox v-model="temp.symptomConstipation" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">便秘</el-checkbox>
                   <el-checkbox v-model="temp.symptomDiarrhea" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">腹泻</el-checkbox>
                   <el-checkbox v-model="temp.symptomNauseaVomiting" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">恶心呕吐</el-checkbox>
                   <el-checkbox v-model="temp.symptomDazzle" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">眼花</el-checkbox>
                   <el-checkbox v-model="temp.symptomTinnitus" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">耳鸣</el-checkbox>
                   <el-checkbox v-model="temp.symptomBreastBursting" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">乳房胀痛</el-checkbox>
                   <el-checkbox v-model="temp.symptomOther" :true-label="'1'" :false-label="'0'" :disabled="temp.asymptomatic == '1'">其它</el-checkbox>
                   <el-input v-model="temp.symptomOtherStr" :disabled="temp.asymptomatic == '1'" placeholder="请输入其他症状"></el-input>
                 </el-form-item>
               </el-col>
             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse>

       <!-- 一般情况 -->
       <xr-collapse  class="single-collapse">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="一般情况">
             <el-row :gutter="24">
               <el-col :span="6">
                 <el-form-item  label="体温">
                   <el-input  v-model="temp.bodyTemperature" placeholder="请输入体温">
                     <template slot="append">°C</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="脉搏">
                   <el-input  v-model="temp.pulseFrequency" placeholder="请输入脉搏">
                      <template slot="append">次/分钟</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="呼吸频率">
                   <el-input  v-model="temp.respiratoryRate" placeholder="请输入呼吸频率">
                      <template slot="append">次/分钟</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="身高">
                   <el-input  v-model="temp.height" placeholder="请输入身高" @change="handleHeightChange">
                      <template slot="append">cm</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="体重">
                   <el-input  v-model="temp.weight" placeholder="请输入体重" @change="handleWeightChange">
                      <template slot="append">kg</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="腰围">
                   <el-input  v-model="temp.waist" placeholder="请输入腰围">
                     <template slot="append">cm</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="体质指数">
                   <el-input  v-model="temp.bmi" placeholder="请输入体质指数" disabled>
                     <template slot="append">Kg/m2</template>
                   </el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="血压(左)">
                   <xr-input-number-range :precision="precision" v-model="bpLeftRange" from-placeholder="收缩压" to-placeholder="舒张压" append="mmHg"  @update-data="handleUpdatePressure" ></xr-input-number-range>
                 </el-form-item>
               </el-col>
               <el-col :span="6">
                 <el-form-item  label="血压(右)">
                   <xr-input-number-range :precision="precision" v-model="bpRightRange" from-placeholder="收缩压" to-placeholder="舒张压" append="mmHg"  @update-data="handleUpdatePressureRight" ></xr-input-number-range>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="老年人健康状态自我评估" label-width="230px">
                   <el-radio-group v-model="temp.elderlyHealthStatus" size="mini">
                    <el-radio-button v-for="option in health_status_dict" :key="option.value" :label="option.value">
                     {{ option.label }}
                     </el-radio-button>
                   </el-radio-group>
                 </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="20">
                  <el-form-item  label="老年人生活自理能力自我评估" label-width="230px">
                    <el-radio-group v-model="temp.elderlySelfCare" size="mini" disabled>
                        <el-radio-button :label="1">可自理（0-3分）</el-radio-button>
                        <el-radio-button :label="2">轻度依赖（4-8分）</el-radio-button>
                        <el-radio-button :label="3">中度依赖（9-18分）</el-radio-button>
                        <el-radio-button :label="4">不能自理（>=19分）</el-radio-button>
                    </el-radio-group>
                     <el-button type="primary">进行评估</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="8">
                  <el-form-item  label="老年人认知能力" label-width="230px">
                    <el-radio-group v-model="temp.elderlyCognitiveFun" size="mini">
                       <el-radio-button :label="1">粗筛阴性</el-radio-button>
                       <el-radio-button :label="2">粗筛阳性</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
               </el-col>
               <el-col :span="10">
                  <el-form-item  label="简易智力状态检查， 总分" label-width="230px">
                     <el-input v-model="temp.miniMentalStateExamination"  style="width: 40%;" disabled>
                       <template slot="append">分</template>
                     </el-input>
                     <el-button type="primary">进行检查</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="8">
                  <el-form-item  label="老年人情感态度" label-width="230px">
                    <el-radio-group v-model="temp.elderlyAffectiveState" size="mini">
                       <el-radio-button :label="1">粗筛阴性</el-radio-button>
                       <el-radio-button :label="2">粗筛阳性</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
               </el-col>
               <el-col :span="10">
                  <el-form-item  label="老年人抑郁评分检查， 总分" label-width="230px">
                     <el-input v-model="temp.elderlyDepressionCheck"  style="width: 40%;" disabled>
                       <template slot="append">分</template>
                     </el-input>
                     <el-button type="primary">进行检查</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="10">
                  <el-form-item  label="痴呆早期筛查问卷， 总分" label-width="230px">
                     <el-input v-model="temp.dementiaScreeningScore" style="width: 50%;" disabled>
                       <template slot="append">分</template>
                     </el-input>
                     <el-button type="primary">进行筛查</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="10">
                  <el-form-item  label="简明社区痴呆筛查量表CSI-D：总分" label-width="250px">
                     <el-input v-model="temp.dementiaScreeningCsidfs" style="width: 49%;" disabled>
                       <template slot="append">分</template>
                     </el-input>
                     <el-button type="primary">进行筛查</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24">
               <el-col :span="10">
                  <el-form-item  label="PHQ-9抑郁筛查量表：总分" label-width="230px">
                     <el-input v-model="temp.dementiaScreeningPhqfs" style="width: 50%;" disabled>
                       <template slot="append">分</template>
                     </el-input>
                     <el-button type="primary">进行筛查</el-button>
                  </el-form-item>
               </el-col>
             </el-row>
           </el-tab-pane>
        </el-tabs>
      </xr-collapse>

     <!-- 生活方式 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="生活方式">
            <medical-life-style
              :form-data="temp"
              :exercise-frequency-dict="exercise_frequency_dict"
              :hardeningModeDict="hardening_mode_dict"
              :smoking-status-dict="smoking_status_dict"
              :drinking-frequency-dict="drinking_frequency_dict"
              @openDictDialog="openDictDialog"
            ></medical-life-style>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

      <!-- 肝脏功能 -->
       <xr-collapse  class="single-collapse">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="肝脏功能">
             <!-- 口腔 -->
             <div class="section-title">
                <i class="el-icon-menu" style="margin-right: 10px;"></i>口腔
                <el-divider></el-divider>
             </div>
             <el-row :gutter="24" style="margin-left: 40px;">
               <!-- 口唇 -->
               <el-col :span="24">
                 <el-form-item label="口唇">
                   <el-radio-group v-model="temp.lips" size="mini">
                     <el-radio-button
                       v-for="option in lips_dict"
                       :key="option.value"
                       :label="option.value">
                       {{ option.label }}
                     </el-radio-button>
                   </el-radio-group>
                 </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px; display: flex; align-items: center;">
               <!-- 齿列 -->
               <el-col :span="24" style="display: flex; align-items: center; flex-wrap: nowrap;">
                 <el-form-item label="齿列" style="margin-right: 10px;">
                    <el-checkbox v-model="temp.dentitiondenture" true-label="'1'" false-label="'0'">正常</el-checkbox>
                 </el-form-item>
                 <el-form-item style="margin-right: 10px;" label-width="20px">
                    <el-checkbox v-model="temp.missTeeth" true-label="'1'" false-label="'0'" :disabled="temp.dentitiondenture === '1'">缺齿</el-checkbox>
                 </el-form-item>
                 <div style="display: inline-block; margin-right: 15px;">
                   <table border="1" cellpadding="0" cellspacing="0" style="width: 100px; height: 60px;border: 1px solid #000;">
                     <tr>
                       <td><el-input v-model="temp.missTeeth1" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.missTeeth2" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                     <tr>
                       <td><el-input v-model="temp.missTeeth3" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.missTeeth4" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                   </table>
                 </div>
                 <el-form-item style="margin-right: 10px;" label-width="20px">
                   <el-checkbox v-model="temp.dentalCary" true-label="'1'" false-label="'0'" :disabled="temp.dentitiondenture === '1'">龋齿</el-checkbox>
                 </el-form-item>
                 <div style="display: inline-block; margin-right: 15px;">
                   <table border="1" cellpadding="0" cellspacing="0" style="width: 100px; height: 60px;">
                     <tr>
                       <td><el-input v-model="temp.dentalCary1" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.dentalCary2" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                     <tr>
                       <td><el-input v-model="temp.dentalCary3" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.dentalCary4" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                   </table>
                 </div>
                 <el-form-item style="margin-right: 10px;" label-width="20px">
                   <el-checkbox v-model="temp.denture" true-label="'1'" false-label="'0'" :disabled="temp.dentitiondenture === '1'">义齿(假牙)</el-checkbox>
                 </el-form-item>
                 <div style="display: inline-block;">
                   <table border="1" cellpadding="0" cellspacing="0" style="width: 100px; height: 60px;">
                     <tr>
                       <td><el-input v-model="temp.denture1" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.denture2" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                     <tr>
                       <td><el-input v-model="temp.denture3" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                       <td><el-input v-model="temp.denture4" size="mini" :disabled="temp.dentitiondenture === '1'"></el-input></td>
                     </tr>
                   </table>
                 </div>
               </el-col>
             </el-row>
             <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
               <!-- 咽部 -->
               <el-col :span="24">
                 <el-form-item label="咽部">
                   <el-radio-group v-model="temp.pharyngealportion" size="mini">
                     <el-radio-button
                       v-for="option in pharyngeal_dict"
                       :key="option.value"
                       :label="option.value">
                       {{ option.label }}
                     </el-radio-button>
                   </el-radio-group>
                 </el-form-item>
               </el-col>
             </el-row>

             <!-- 视力 -->
             <div class="section-title">
                <i class="el-icon-menu" style="margin-right: 10px;"></i>视力
                <el-divider></el-divider>
             </div>
             <el-row :gutter="24" style="margin-left: 40px;">
               <el-col :span="8">
                 <el-form-item label="视力(左眼)">
                   <el-input v-model="temp.visionLeftEye" placeholder="请输入" size="mini"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="8">
                 <el-form-item label="视力(右眼)">
                   <el-input v-model="temp.visionRightEye" placeholder="请输入" size="mini"></el-input>
                 </el-form-item>
               </el-col>
             </el-row>
             <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
               <el-col :span="8">
                 <el-form-item label="矫正视力(左眼)" label-width="130px">
                   <el-input v-model="temp.straightenVisionLeftEye" placeholder="矫正视力(左眼)" size="mini"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="8">
                 <el-form-item label="矫正视力(右眼)" label-width="130px">
                   <el-input v-model="temp.straightenVisionRightEye" placeholder="矫正视力(右眼)" size="mini"></el-input>
                 </el-form-item>
               </el-col>
             </el-row>

             <!-- 听力 -->
             <div class="section-title">
                <i class="el-icon-menu" style="margin-right: 10px;"></i>听力
                <el-divider></el-divider>
             </div>
             <el-row :gutter="24" style="margin-left: 40px;">
               <el-col :span="12">
                 <el-form-item label="听力">
                   <el-radio-group v-model="temp.audition" size="mini">
                     <el-radio-button
                       v-for="option in hearing_dict"
                       :key="option.value"
                       :label="option.value">
                       {{ option.label }}
                     </el-radio-button>
                   </el-radio-group>
                 </el-form-item>
               </el-col>
             </el-row>

             <!-- 运动功能 -->
             <div class="section-title">
                <i class="el-icon-menu" style="margin-right: 10px;"></i>运动功能
                <el-divider></el-divider>
             </div>
             <el-row :gutter="24" style="margin-left: 40px;">
               <el-col :span="12">
                 <el-form-item label="运动能力">
                   <el-radio-group v-model="temp.motorFunction" size="mini">
                     <el-radio-button
                       v-for="option in motor_function_dict"
                       :key="option.value"
                       :label="option.value">
                       {{ option.label }}
                     </el-radio-button>
                   </el-radio-group>
                 </el-form-item>
               </el-col>
             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse>

      <!-- 查体 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="查体">
            <medical-physical-exam
              :formData="temp"
              :skinDict="skin_dict"
              :scleraDict="sclera_dict"
              :lymphNodeDict="lymph_node_dict"
              :raleDict="rale_dict"
              :rhythmHeartDict="rhythm_heart_dict"
              :lowerEdemaDict="lower_edema_dict"
              :footPulsesDict="foot_pulses_dict"
              :anusDreDict="anus_dre_dict"
              :eyegroundExceptionDict="eyeground_exception_dict"
              :skinOthersDict="skin_others_dict"
              :scleraOthersDict = "sclera_others_dict"
              :lymphNodeOthersDict = "lymphNode_others_dict"
              @openDictDialog="openDictDialog"
            ></medical-physical-exam>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

      <!-- 辅助检查 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="辅助检查">
            <medical-auxiliary-exam
              :formData="temp"
              :proteinuriaDict="proteinuria_dict"
              :urineSugarDict="urineSugar_dict"
              :cxrExceptionDict="cxrException_dict"
              :typeBUltrasonicExcepDict="typeBUltrasonicExcep_dict"
              :urineRoutineOthersDict = "urineRoutineOthers_Dict"
              @openDictDialog="openDictDialog"></medical-auxiliary-exam>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

    <!-- 主要问题与治疗 -->
    <medical-problems
      :formData="temp"
      :drugNameDict="drug_name_dict"
      :drugUsageDict="drug_usage_dict"
      :drugDosageDict="drug_dosage_dict"
      :niVaccinationNameDict="ni_vaccination_name_dict"
      :medicalOrgNameDict="medical_orgName_dict"
      @openDictDialog="openDictDialog"></medical-problems>

    <!-- 其他检查 -->
    <medical-other :formData="temp"  :hazardOthersDict="hazard_others_dict" @openDictDialog="openDictDialog"></medical-other>
  </el-form>
  <!-- 字典 -->
  <medical-dict-index ref="medicalDictIndex" v-if="isMedicalDictIndexShow" @refreshParentData="handleRefreshDictData"></medical-dict-index>

  <!-- 老年人生活自理能力自我评估 -->
  <elderly-self-care ref="elderlySelfCare" v-if="isElderlySelfCareShow"></elderly-self-care>
</div>
</template>
<script>
import MedicalPhysicalExam from './medical-physical'
import MedicalAuxiliaryExam from './medical-auxiliary'
import MedicalProblems from './medical-problems'
import MedicalOther from './medical-other'
import MedicalLifeStyle from './medical-lifeStyle'
import MedicalDictIndex from '../../dict/medical_dict_index'
import ElderlySelfCare from './evaluate/elderly-self-care'

  export default {
    name: "healRecordReport",
    props:['medicalNo'],
    components: {
      MedicalPhysicalExam,
      MedicalAuxiliaryExam,
      MedicalProblems,
      MedicalOther,
      MedicalLifeStyle,
      MedicalDictIndex
    },
    data() {
      return {
        isMedicalDictIndexShow: false,       //是否显示字典表列表
        isElderlySelfCareShow: false,        //是否显示老年人生活自理能力自我评估
        loading: false,
        activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        precision: 0,
        bpLeftRange: ["", ""],
        bpRightRange:["",""],
        health_status_dict:[],               //老年人健康状态自我评估
        urineRoutineOthers_Dict:[],         //尿常规 其它
        exercise_frequency_dict:[],         //锻炼频率
        hardening_mode_dict:[],             //锻炼方式
        smoking_status_dict:[],             //吸烟情况
        drinking_frequency_dict:[],         //饮酒频率
        lips_dict:[],                       //口腔-口唇
        pharyngeal_dict:[],                 //口腔-咽部
        hearing_dict:[],                    //口腔-听力
        motor_function_dict:[],             //口腔-运动功能
        skin_dict:[],                        //皮肤
        sclera_dict:[],                      //巩膜
        lymph_node_dict:[],                  //淋巴结
        rale_dict:[],                        //罗音
        rhythm_heart_dict:[],                //心率
        lower_edema_dict:[],                 //下肢水肿
        foot_pulses_dict:[],                 //足背动脉搏动
        anus_dre_dict:[],                    //肛门指诊
        drug_name_dict:[],                   //药品名称
        drug_usage_dict:[],                  //药品用法
        drug_dosage_dict:[],                 //药品用量
        ni_vaccination_name_dict:[],         //预防接种名称
        medical_orgName_dict:[],             //接种机构
        hazard_others_dict:[],              //健康指导：其它
        eyeground_exception_dict:[],        //查体：眼底异常
        skin_others_dict:[],                //查体：皮肤其它
        sclera_others_dict:[],              //查体：巩膜其他
        lymphNode_others_dict:[],           //查体：淋巴结其它
        proteinuria_dict:[],                //辅助检查：尿蛋白
        urineSugar_dict:[],                 //辅助检查：尿糖
        urineOccultBlood_dict:[],           //辅助检查：尿潜血
        cxrException_dict:[],               //辅助检查：胸部X片异常情况
        typeBUltrasonicExcep_dict:[],       //辅助检查：超声异常情况

        temp: {
          // 基本信息
          id:'',
          archiveCode:'',
          medicalNo: '',
          sickName: '',
          medicalTime: '',
          medicalOper: '',
          medicalOperatorName:'',
          medicalWay:'',
          medicalWayName: '',
          manageTeamName: '',
          createdByName: '',
          createdByTeamName:'',
          teamName:'',

          // 症状
          asymptomatic: '',
          symptomHeadache: '',
          symptomDizziness: '',
          symptomPalpitation: '',
          symptomChestStuffiness: '',
          symptomChestPain: '',
          symptomChronicCough: '',
          symptomExpectoration: '',
          symptomDyspnea: '',
          symptomPolydipsia: '',
          symptomPolyuria: '',
          symptomWeightLoss: '',
          symptomLackOfPower: '',
          symptomJointGall: '',
          symptomBlurredVision: '',
          symptomHandFootNumbness: '',
          symptomUrinaryUrgency: '',
          symptomDysuria: '',
          symptomConstipation: '',
          symptomDiarrhea: '',
          symptomNauseaVomiting: '',
          symptomDazzle: '',
          symptomTinnitus: '',
          symptomBreastBursting: '',
          symptomOther: '',
          symptomOtherStr: '',

          // 一般情况
          bodyTemperature: '',
          pulseFrequency: '',
          respiratoryRate: '',
          height: '',
          weight: '',
          waist: '',
          bmi: '',
          bloodPressuL: '',
          bloodPressuR: '',
          bloodPressureLeftU:'',
          bloodPressureLeftD:'',
          bloodPressureRigthU:'',
          bloodPressureRigthD:'',
          elderlyHealthStatus:'',
          elderlySelfCare:'',
          elderlyCognitiveFun:'',
          miniMentalStateExamination:'',
          elderlyAffectiveState:'',
          elderlyDepressionCheck:'',
          dementiaScreeningScore:'',
          dementiaScreeningCsidfs:'',
          dementiaScreeningPhqfs:'',

          //生活方式
          hardeningFrequency:'',
          everyHardeningTime: '',
          insistHardeningTime:'',
          hardeningMode:'',

          //吸烟情况
          smokingCircumstance: '',
          dailySmokingQuantity: '',
          beginSmokingAge: '',
          quitSmokingAge: '',
          eatClitocybineEqualization:'',
          eatHobbySalt: '',
          eatHobbyOil: '',
          eatHobbySugar: '',

          // 饮酒情况
          drinkFrequency: '',
          everyAlcoholTolerance: '',
          isDryOut: '',
          dryOutAge: '',
          beginDrinkAge: '',
          oneYearIsTemulentia: '',
          drinkWhiteSpirits:'',
          drinkBeer:'',
          drinkRedWine:'',
          drinkYellowWine:'',
          drinkOthers: '',

          //职业病危害因素
          //职业病危害因素-粉尘
          occHazHistory0:'',
          occHazHistory1:'',
          poisonDust:'',
          hazardNameDust:'',
          workTimeDust:'',
          poisonDustIspre:'',
          //职业病危害因素-放射物质
          occHazHistory2:'',
          poisonRadiogen:'',
          hazardNameRad:'',
          workTimeRad:'',
          poisonRadiogenIspre:'',

          //职业病危害因素-物理
          occHazHistory3:'',
          poisonPhysicalfactor:'',
          hazardNamePhy:'',
          workTimePhy:'',
          poisonPhysicalIspre:'',

          //职业病危害因素-化学
          occHazHistory4:'',
          poisonChemical:'',
          hazardNameChe:'',
          workTimeChe:'',
          poisonChemicalIspre:'',

         //职业病危害因素-其它
         occHazHistory5:'',
         poisonOthers:'',
         hazardNameOth:'',
         workTimeOth:'',
         poisonOthersIspre:'',

          // 口腔
          lips: '',                           //口唇
          dentitiondenture:'',                //齿列-正常
          missTeeth: '',                      //齿列-缺齿
          missTeeth1: '',                     //齿列-缺齿1
          missTeeth2: '',                     //齿列-缺齿2
          missTeeth3: '',                     //齿列-缺齿3
          missTeeth4: '',                     //齿列-缺齿4
          dentalCary: '',                     //齿列-龋齿
          dentalCary1: '',                    //齿列-龋齿1
          dentalCary2: '',                    //齿列-龋齿2
          dentalCary3: '',                    //齿列-龋齿3
          dentalCary4: '',                    //齿列-龋齿4
          denture: '',                        //齿列-义齿(假牙)
          denture1: '',                       //齿列-义齿1
          denture2: '',                       //齿列-义齿2
          denture3: '',                       //齿列-义齿3
          denture4: '',                       //齿列-义齿4
          pharyngealportion: '',              //咽部

          // 视力
          visionLeftEye: '',                   //视力-左眼
          visionRightEye: '',                  //视力-右眼
          straightenVisionLeftEye: '',         //矫正视力-左眼
          straightenVisionRightEye: '',        //矫正视力-右眼


          audition: '',                           //听力
          motorFunction: '',                     //运动能力

          // 查体
          eyeground: '',                         //眼底是否正常
          eyegroundException: '',                    //眼底异常描述
          skin: '',                              //皮肤
          skinOthers: '',                        //皮肤其他
          sclera: '',                            //巩膜
          scleraOthers: '',                      //巩膜其他
          lymphNode: '',                         //淋巴结
          lymphNodeOthers: '',                   //淋巴结其他
          lungBarrelChest: '',                   //肺-桶状胸
          lungBreathSound: '',                   //肺-呼吸音
          lungBreathSoundExcep: '',              //肺-呼吸音异常说明
          lungRhonchus: '',                      //肺-罗音
          lungRhonchusException: '',             //肺-罗音其他
          heartRate: '',                         //心脏-心率
          cardiacRhythm: '',                     //心脏-心律
          cardiacSouffle: '',                    //心脏-杂音
          cardiacSouffleOthers: '',              //心脏-杂音其他
          abdoPressPain: '',                     //腹部-压痛
          abdoPressPainOth: '',                  //腹部-压痛描述
          abdoMasses: '',                        //腹部-包块
          abdoMassesOthers: '',                  //腹部-包块描述
          abdoHepatomegaly: '',                  //腹部-肝大
          abdoHepatomegalyOth: '',               //腹部-肝大描述
          abdoSplenomegaly: '',                  //腹部-脾大
          abdoSplenomegalyOth: '',               //腹部-脾大描述
          abdoShiftingDull: '',                  //腹部-移动性浊音
          abdoShiftingDullOth: '',               //腹部-移动性浊音描述
          immersionFoot: '',                     //下肢水肿
          dorsumOfFootArteriopalmus: '',         //足背动脉搏动
          fundamentFingerp: '',                  //肛门指诊
          fundamentFingerpOth: '',               //肛门指诊其他
          breastNotTroubleFind: '',              //乳腺 未及异常
          breastMastectomy:'',
          breastAbnormalLactation:'',
          breastMasses:'',
          breastOthers:'',
          breastOthersStr: '',                   //乳腺其他描述
          vulva: '',                             //妇科-外阴
          vulvaException: '',                        //妇科-外阴异常
          vagina: '',                            //妇科-阴道
          vaginaException: '',                       //妇科-阴道异常
          cervix: '',                            //妇科-宫颈
          cervixException: '',                       //妇科-宫颈异常
          corpus: '',                            //妇科-宫体
          corpusException: '',                       //妇科-宫体异常
          attachment: '',                        //妇科-附件
          attachmentException: '',                   //妇科-附件异常
          physicalExaminationOth: '',            //其他

          // 辅助检查
          // 血常规
          hemoglobin: '',
          platelet: '',
          leukocyte: '',
          wbc1: '',
          wbc2: '',
          wbc3: '',
          bloodRoutineOthers: '',
          bloodRoutineRefuse:'',                //血常规-拒检
          bloodRoutineOutside:'',               //血常规-外院
          bloodRoutineOutsideOthers:'',         //血常规-其它

          // 尿常规
          proteinuria: '',
          ketonuria: '',
          urineSugar:'',
          ket:'',
          urinaryOccultBlood: '',
          urineRoutine: '',
          urineRoutineOthers: '',
          urineRoutineRefuse:'',               //尿常规-拒检
          urineRoutineOutside:'',             //尿常规-外院
          urineRoutineOutsideOthers:'',       ////尿常规-其它

          // 血糖
          fastingPlasmaGlucoseL: '',
          randomBloodSugar: '',
          randomGlucose: '',                //血糖-随机血糖
          glucoseRefuse : '',               //血糖-拒检
          glucoseOutside : '',              //血糖-外院
          glucoseRoutineOutsideOthers: '',  //血糖-其它

          // 心电图
          electrocardiogram: '',
          electrocardiogramExcep: '',
          electrocardiogramRefuse : '',   //拒检
          electrocardiogramOutside : '',   //外院
          electOutsideOthers: '',         //其它

          // 尿微量白蛋白
          microalbuminuria: '',
          microalbuminuriaRefuse : '',   //拒检
          microalbuminuriaOutside: '',   //外院
          micOutsideOthers:'',            //其它

          // 大便潜血
          stoolOccultBlood: '',
          stoolOccultBloodRefuse: '',
          stoolOccultBloodOutside: '',
          stoolOutsideOthers: '',

          // 糖化血红蛋白
          glycolatedHemoglobin: '',
          glycolatedHemoglobinRefuse: '',
          glycolatedHemoglobinOutside: '',
          glycatedOutsideOthers: '',

          //乙型肝炎表面抗原
          hbsag:'',
          hbsagRefuse: '',
          hbsagOutside: '',
          hbsagOutsideOthers: '',

          // 肝功能
          liverFunctionSalt: '',
          liverFunctionTotalBilirubin: '',
          liverFunctionAlbumin: '',
          liverFunctionSgot: '',
          liverFunctionCb: '',
          liverFunAlbAll: '',
          liverFunctionRefuse: '',
          liverFunctionOutside: '',
          liverOutsideOthers: '',

          // 肾功能
          renalFunctionCreatinine: '',
          renalFunctionBun: '',
          renalFunctionBloodPotassium: '',
          renalFunctionNatremia: '',
          renalFailureUricAcid: '',
          renalFunctionRefuse: '',
          renalFunctionOutside: '',
          renalOutsideOthers: '',

          // 血脂
          bloodFatTc: '',
          bloodFatTriglyceride: '',
          bloodFatLdlc: '',
          bloodFatHdlc: '',
          bloodFatRefuse: '',
          bloodFatOutside: '',
          bloodFatOutsideOthers: '',

          // 胸部X线片
          cxr: '',
          cxrException: '',
          cxrRefuse: '',
          cxrOutside: '',
          cxrOutsideOthers: '',

          // B超
          typeBUltrasonic: '',
          typeBUltrasonicExcep: '',
          typeBUltrasonicRefuse: '',
          typeBUltrasonicOutside: '',
          typeBOutsideOthers: '',
          typeBUltrasonicQt: '',
          typeBUltrasonicExcepQt: '',

          // 宫颈涂片
          cervicalPapSmears: '',
          cervicalPapSmearsExcep: '',
          cervicalPapSmearsRefuse: '',
          cervicalPapSmearsOutside: '',
          cervicalOutsideOthers: '',

          // 其它
          assistantInvesOth: '',

          // 其他检查
          otherCheck1: '',
          otherResult1: '',
          otherCheck2: '',
          otherResult2: '',
          otherCheck3: '',
          otherResult3: '',

          // 脑血管疾病
          cvdUndiscovered: '',
          cvdIschemicStroke: '',
          cvdCerebralHemorrhage: '',
          cvdSah: '',
          cvdTia: '',
          cvdOthers: '',
          cvdOthersStr: '',

          // 肾脏疾病
          renalUndiscovered: '',
          renalDn: '',
          renalFailure: '',
          renalAgn: '',
          renalCgn: '',
          renalOthers: '',
          renalOthersStr: '',

          // 心脏疾病
          heartUndiscovered: '',
          heartMyocardialInfarction: '',
          heartAnginaPectoris: '',
          heartCoronaryArtery: '',
          heartChf: '',
          heartPrecordialpain: '',
          cHeartDis: '',
          heartOthers: '',
          heartOthersStr: '',

          // 血管疾病
          angiosisUndiscovered: '',
          hypertension: '',
          angiosisDa: '',
          angiosisOcclusionArteries: '',
          angiosisOthers: '',
          angiosisOthersStr: '',

          // 眼部疾病
          eyeDiseaseUndiscovered: '',
          retinalHemorrhage: '',
          papilledema: '',
          eyeDiseaseCataract: '',
          eyeDiseaseOthers: '',
          eyeDiseaseOthersStr: '',

          // 神经系统疾病
          nervousSystemDisease: '',
          nervousSystemDiseaseStr: '',

          // 内分泌系统疾病
          enmedis: '',
          enmedisOther: '',

          // 其他系统疾病
          otherDiseaseNo: '',
          otherDiseaseStr: '',

          // 住院史
          inhospital: '',
          inhospitalAdmissionDate1: '',
          inhospitalLeaveDate1: '',
          inhospitalCause1: '',
          inhospitalOrgName1: '',
          inhospitalPatientId1: '',
          inhospitalAdmissionDate2: '',
          inhospitalLeaveDate2: '',
          inhospitalCause2: '',
          inhospitalOrgName2: '',
          inhospitalPatientId2: '',

          // 家庭病床史
          fpHistory: '',
          fpEstablishDate1: '',
          fpCancelDate1: '',
          fpCause1: '',
          fpOrgName1: '',
          fpPatientId1: '',
          fpEstablishDate2: '',
          fpCancelDate2: '',
          fpCause2: '',
          fpOrgName2: '',
          fpPatientId2: '',

          // 主要用药情况
          drugName1: '',
          drugName2: '',
          drugName3: '',
          drugName4: '',
          drugName5: '',
          drugName6: '',
          drugUsage1: '',
          drugUsage2: '',
          drugUsage3: '',
          drugUsage4: '',
          drugUsage5: '',
          drugUsage6: '',
          drugDosage1: '',
          drugDosage2: '',
          drugDosage3: '',
          drugDosage4: '',
          drugDosage5: '',
          drugDosage6: '',
          drugDate1: '',
          drugDate2: '',
          drugDate3: '',
          drugDate4: '',
          drugDate5: '',
          drugDate6: '',
          drugCompliance1: '',
          drugCompliance2: '',
          drugCompliance3: '',
          drugCompliance4: '',
          drugCompliance5: '',
          drugCompliance6: '',

          // 非免疫规划预防接种史
          niVaccinationName1: '',
          niVaccinationName2: '',
          niVaccinationName3: '',
          niVaccinationDate1: '',
          niVaccinationDate2: '',
          niVaccinationDate3: '',
          niVaccinationOrg1: '',
          niVaccinationOrg2: '',
          niVaccinationOrg3: '',

          // 健康评价
          healthAss1: '',
          healthAssXsxf: '',
          healthAssGxf: '',
          healthAssTxf: '',
          healthAssQtxf: '',
          healthAss21: '',
          healthAss22: '',
          healthAss23: '',
          healthAss24: '',
          healthAss25: '',
          healthAss26: '',
          healthAssRemark: '',

          // 健康指导
          healthGuidanceSlowDisease: '',
          healthGuidanceInhospital: '',
          healthGuidanceReview: '',
          hazardQuitSmocking: '',
          hazardHealthDrink: '',
          hazardFood: '',
          hazardHardening: '',
          hazardLoseWeight: '',
          hazardLoseWeightTarget: '',
          hazardVaccination: '',
          hazardVaccinationStr: '',
          hazardOthers: '',
          hazardOthersStr: '',

          medicalNextTime:'',   //下次体检日期
          mainDoctorsName:'', //责任医师姓名
          remark:'', //备注


        },
        rules: {
        },
      }
    },
    methods: {
      //打开字典维护弹窗
      openDictDialog(dictType) {
        this.isMedicalDictIndexShow = true
        this.$nextTick(() => {
          this.$refs.medicalDictIndex.init(dictType);
        });
      },
      //检查地点
      handleMedicalWayChange(val) {
        const medicalWayMap = {
          '1': '门诊',
          '2': '家庭',
          '3': '其它'
        };
        this.temp.medicalWayName = medicalWayMap[val] || '';
      },
      //无症状变化处理
      handleAsymptomaticChange(val) {
        if (val == '1') {
          this.temp.symptomHeadache = '';
          this.temp.symptomDizziness = '';
          this.temp.symptomPalpitation = '';
          this.temp.symptomChestStuffiness = '';
          this.temp.symptomChestPain = '';
          this.temp.symptomChronicCough = '';
          this.temp.symptomExpectoration = '';
          this.temp.symptomDyspnea = '';
          this.temp.symptomPolydipsia = '';
          this.temp.symptomPolyuria = '';
          this.temp.symptomWeightLoss = '';
          this.temp.symptomLackOfPower = '';
          this.temp.symptomJointGall = '';
          this.temp.symptomBlurredVision = '';
          this.temp.symptomHandFootNumbness = '';
          this.temp.symptomUrinaryUrgency = '';
          this.temp.symptomDysuria = '';
          this.temp.symptomConstipation = '';
          this.temp.symptomDiarrhea = '';
          this.temp.symptomNauseaVomiting = '';
          this.temp.symptomDazzle = '';
          this.temp.symptomTinnitus = '';
          this.temp.symptomBreastBursting = '';
          this.temp.symptomOther = '';
          this.temp.symptomOtherStr = '';
        }
      },
      //初始化
      init(medicalNo) {
        if (medicalNo) {
          this.temp.medicalNo = medicalNo;
        }
        this.getPageInfo();    //获取表单数据
        this.getListInfo();   //获取字典数据
      },
      //获取页面所需数据
      getPageInfo(){
        this.loading = true;
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhDataExamine_getPhPageInfo',
            'medicalNo': this.temp.medicalNo,
            'type':'edit'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(response.data){
            if (response.data.info) {
              this.temp = response.data.info;
              if(!this.temp.asymptomatic){
                this.temp.asymptomatic = '';
              }
              // 初始化血压范围
              this.bpLeftRange = [this.temp.bloodPressureLeftU || "", this.temp.bloodPressureLeftD || ""];
              this.bpRightRange = [this.temp.bloodPressureRigthU || "", this.temp.bloodPressureRigthD || ""];
            }

          }
        }).catch(error => {
          this.$message.error('查询体检信息失败！');
        }).finally(() => {
          this.loading = false;
        });
      },
      //获取页面数据字典
      getListInfo(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhDataExamine_getListInfo',
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(response.data){
            if(response.data.health_status_dict){                    //老年人健康状态自我评估
              this.health_status_dict = response.data.health_status_dict
            }
            if(response.data.exercise_frequency_dict){               //锻炼频率
              this.exercise_frequency_dict = response.data.exercise_frequency_dict
            }
            if(response.data.hardening_mode_dict){                  //锻炼方式
              this.hardening_mode_dict = response.data.hardening_mode_dict
            }
            if(response.data.smoking_status_dict){                  //吸烟情况
              this.smoking_status_dict = response.data.smoking_status_dict
            }
            if(response.data.drinking_frequency_dict){              //饮酒频率
              this.drinking_frequency_dict = response.data.drinking_frequency_dict
            }
            if(response.data.lips_dict){                            //口腔-口唇
              this.lips_dict = response.data.lips_dict
            }
            if(response.data.pharyngeal_dict){                      //咽部
              this.pharyngeal_dict = response.data.pharyngeal_dict
            }
            if(response.data.hearing_dict){                         //听力
              this.hearing_dict = response.data.hearing_dict
            }
            if(response.data.motor_function_dict){                       //运动功能
              this.motor_function_dict = response.data.motor_function_dict
            }
            if(response.data.skin_dict){                           //皮肤
              this.skin_dict = response.data.skin_dict
            }
            if(response.data.sclera_dict){                         //巩膜
              this.sclera_dict = response.data.sclera_dict
            }
            if(response.data.lymph_node_dict){                     //淋巴结
              this.lymph_node_dict = response.data.lymph_node_dict
            }
            if(response.data.rale_dict){                           //罗音
              this.rale_dict = response.data.rale_dict
            }
            if(response.data.rhythm_heart_dict){                   //心率
              this.rhythm_heart_dict = response.data.rhythm_heart_dict
            }
            if(response.data.lower_edema_dict){                   //下肢水肿
              this.lower_edema_dict = response.data.lower_edema_dict
            }
            if(response.data.foot_pulses_dict){                  //足背动脉搏动
              this.foot_pulses_dict = response.data.foot_pulses_dict
            }
            if(response.data.anus_dre_dict){                     //肛门指诊
              this.anus_dre_dict = response.data.anus_dre_dict
            }
            if(response.data.drug_name_dict){                     //药品名称
              this.drug_name_dict = response.data.drug_name_dict
            }
            if(response.data.drug_usage_dict){                     //药品用法
              this.drug_usage_dict = response.data.drug_usage_dict
            }
            if(response.data.drug_dosage_dict){                     //药品用量
              this.drug_dosage_dict = response.data.drug_dosage_dict
            }
            if(response.data.ni_vaccination_name_dict){             //预防接种名称
              this.ni_vaccination_name_dict = response.data.ni_vaccination_name_dict
            }
            if(response.data.medical_orgName_dict){                //接种机构
              this.medical_orgName_dict = response.data.medical_orgName_dict
            }
            if(response.data.hazard_others_dict){                 //健康指导:其它
              this.hazard_others_dict = response.data.hazard_others_dict
            }
            if(response.data.urineRoutineOthers_Dict){             //尿常规 其它
              this.urineRoutineOthers_Dict = response.data.urineRoutineOthers_Dict
            }
            if(response.data.eyeground_exception_dict){            //查体：眼底异常
              this.eyeground_exception_dict = response.data.eyeground_exception_dict
            }
            if(response.data.skin_others_dict){                   //查体：皮肤其它
              this.skin_others_dict = response.data.skin_others_dict
            }
            if(response.data.sclera_others_dict){                 //查体：巩膜其他
              this.sclera_others_dict = response.data.sclera_others_dict
            }
            if(response.data.lymphNode_others_dict){              //查体：淋巴结其它
              this.lymphNode_others_dict = response.data.lymphNode_others_dict
            }
            if(response.data.proteinuria_dict){                   //辅助检查：尿蛋白
              this.proteinuria_dict = response.data.proteinuria_dict
            }
            if(response.data.urineSugar_dict){                    //辅助检查：尿糖
              this.urineSugar_dict = response.data.urineSugar_dict
            }
            if(response.data.urineOccultBlood_dict){              //辅助检查：尿潜血
              this.urineOccultBlood_dict = response.data.urineOccultBlood_dict
            }
            if(response.data.cxrException_dict){                  //辅助检查：胸部X片异常情况
              this.cxrException_dict = response.data.cxrException_dict
            }
            if(response.data.typeBUltrasonicExcep_dict){          //辅助检查：超声异常情况
              this.typeBUltrasonicExcep_dict = response.data.typeBUltrasonicExcep_dict
            }
          }
        })
      },
      //更新血压(左)
      handleUpdatePressure(systolic, diastolic){
        this.temp.bloodPressureLeftU = systolic;
        this.temp.bloodPressureLeftD = diastolic;
      },
      //更新血压(右)
      handleUpdatePressureRight(systolic, diastolic){
        this.temp.bloodPressureRigthU = systolic;
        this.temp.bloodPressureRigthD = diastolic;
      },
      //保存
      save(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let formData = new FormData();
            formData.append('method', 'tPhDataExamine_edit');
            for (let key in this.temp) {
              if (this.temp.hasOwnProperty(key)) {
                let value = this.temp[key];
                if (value !== null && value !== undefined) {
                  formData.append(key, value);
                }
              }
            }
            return this.request({
              method: 'post',
              url: '/web/service',
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              data: formData
            }).then((response) =>{
              if (response.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.dialogVisible = false
                    this.$emit('refreshTree')
                  }
                })
              } else {
                this.$message.error(response.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //编辑体重
      handleWeightChange(){
        this.calculateBMI()
      },
      //编辑身高
      handleHeightChange(){
        this.calculateBMI()
      },
      //计算BMI：BMI = 体重(kg) / 身高(m)²
      calculateBMI(){
        if(!this.temp.height || this.temp.height <= 0){
          this.temp.bmi = '';
          this.temp.guideBmi = '';
          this.temp.bmiRange = ['', ''];
          return;
        }
        const heightInMeter = this.temp.height / 100; // 转换为米
        // 计算当前BMI
        if(this.temp.weight && this.temp.weight > 0){
          const bmi = this.temp.weight / (heightInMeter * heightInMeter);
          this.temp.bmi = parseFloat(bmi.toFixed(this.bmiPrecision));
        } else {
          this.temp.bmi = '';
        }

        // 计算指导BMI
        if(this.temp.guideWeight && this.temp.guideWeight > 0){
          const guideBmi = this.temp.guideWeight / (heightInMeter * heightInMeter);
          this.temp.guideBmi = parseFloat(guideBmi.toFixed(this.bmiPrecision));
        } else {
          this.temp.guideBmi = '';
        }
        // 更新bmiRange数组
        this.temp.bmiRange = [this.temp.bmi, this.temp.guideBmi];
      },
      resetTemp(){
        this.temp.id=''
      },
      //刷新页面字典数据
      handleRefreshDictData() {
        this.getListInfo();
      },
    }
  }
</script>

<style scoped>
  .main-box{
    overflow-x: hidden;
    overflow-y: auto;
  }
  .custom-fieldset {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 10px;
  }

  /* legend 样式：设置颜色、加粗和位置 */
  .custom-legend {
    /* color: #F56C6C; */
    font-weight: bold;
    font-size: 12px;
    padding: 0 10px;
  }

  /* 模块标题样式 */
  .section-title {
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 15px;
    color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-info.vue